import { useEffect } from "react"

import { Flex, Modal, Typography } from "antd"
import { useDispatch, useSelector } from "react-redux"
import { useParams } from "react-router"

import Icon from "../../../../../Icon"
import ReferralActions from "../../../reducer"
import PaymentDetails from "./PaymentDetails"

import "./PaymentMethodDetailsModal.less"

const { Text } = Typography

const PaymentMethodDetailsModal = ({ open, close, onChangePaymentMethod }) => {
  const dispatch = useDispatch()
  const { id } = useParams()
  const { outsiderPayoutMethod, outsiderPayoutMethodFetching } = useSelector(
    (state) => state.referrals
  )
  const { isAdmin } = useSelector((state) => state.auth)
  const isMobile = useSelector((state) => state.nav.isMobile)
  const adminParams = isAdmin && id ? { user_id: id } : {}

  useEffect(() => {
    if (open) {
      dispatch(ReferralActions.getOutsiderPayoutMethodRequest(adminParams))
    }
  }, [open])

  return (
    <Modal
      open={open}
      onClose={close}
      onCancel={close}
      onOk={close}
      title={
        <Flex vertical gap={12}>
          <Text className="title">Payment details</Text>
          <Text type="secondary" strong>
            View and manage your payment methods for withdrawals
          </Text>
        </Flex>
      }
      closeIcon={<Icon type="cross_small" />}
      cancelText="Change payment method"
      okText="Done"
      okButtonProps={{
        size: "large"
      }}
      cancelButtonProps={{
        size: "large",
        onClick: onChangePaymentMethod,
        disabled: isAdmin
      }}
      rootClassName="payment-method-details-modal clear-bg"
      classNames={{
        content: "clear-bg"
      }}
      width={isMobile ? "100%" : 442}
      centered={!isMobile}
      wrapClassName={isMobile ? "payment-method-details-modal--mobile" : ""}
      getContainer={isMobile ? document.body : () => document.getElementById("global-wrap")}
      loading={outsiderPayoutMethodFetching}
    >
      <PaymentDetails paymentMethod={outsiderPayoutMethod} isMaskedBankDetails={true} />
    </Modal>
  )
}

export default PaymentMethodDetailsModal
